<app-error [configuration]="config"> </app-error>
